import SeoHelper from './lib/SeoHelper.js';
import TextUtils from './lib/TextUtils.js';
import Markup from './lib/Markup.js';

const checks = [
	{
		id: 'too-long-sentences',
		label: 'No sentences with more than [maxWordsPerSentence] words',
		section: 'content',
		test: (pageContent, settings) => {
			let {content} = pageContent;
			if (!content) {
				return {
					status: true
				};
			}
			content = content.replaceAll('</p>', '.</p>');
			content = content.replaceAll('</h1>', '.</h1>');
			content = content.replaceAll('</h2>', '.</h2>');
			content = content.replaceAll('</h3>', '.</h3>');
			content = content.replaceAll('</h4>', '.</h4>');
			content = content.replaceAll('</h5>', '.</h5>');
			content = content.replaceAll('</h6>', '.</h6>');
			content = content.replaceAll('</li>', '.</li>');
			content = Markup.stripTags(content);
			const sentences = content.split(/\.|\?|!/).filter((s) => !!s.trim());
			var tooLongSentences = false;
			if (sentences && sentences.length) {
				sentences.forEach((s) => {
					if (!tooLongSentences) {
						let wordCount = TextUtils.countWords(s);
						tooLongSentences = wordCount > parseInt(settings.maxWordsPerSentence);
					}
				});
			}
			return {
				status: !tooLongSentences
			}
		},
		showProblem: (settings) => {
			const editor = document.querySelector('.ql-editor');

			let editorContent = document.createElement('div');
			editorContent.innerHTML = editor.innerHTML;

			let content = SeoHelper.unmarkText(editorContent.innerHTML);
			if (!content) {
				return false;
			}

			content = content.replaceAll('</p>', '.</p>');
			content = content.replaceAll('</h1>', '.</h1>');
			content = content.replaceAll('</h2>', '.</h2>');
			content = content.replaceAll('</h3>', '.</h3>');
			content = content.replaceAll('</h4>', '.</h4>');
			content = content.replaceAll('</h5>', '.</h5>');
			content = content.replaceAll('</h6>', '.</h6>');
			content = content.replaceAll('</li>', '.</li>');
			const originalSentences = content.split(/\.|\?|!/).filter((s) => !!s.trim()).map((s) => s.replaceAll('</p><p>', ''));

			if (originalSentences && originalSentences.length) {
				content = Markup.stripTags(content);
				const sentences = content.split(/\.|\?|!/).filter((s) => !!s.trim());

				let markup = SeoHelper.unmarkText(editorContent.innerHTML);

				sentences.forEach((s) => {
					if (TextUtils.countWords(s) > parseInt(settings.maxWordsPerSentence)) {
						s = s.trim();
						for (let i = 0; i < originalSentences.length; i++) {
							let clearedOriginal = Markup.stripTags(originalSentences[i]).trim();
							if (clearedOriginal === s) {
								markup = markup.replaceAll(originalSentences[i], `<mark>${originalSentences[i]}</mark>`);
							}
						}
					}
				});

				if (markup !== editor.innerHTML) {
					markup = Markup.removeEmptyLines(markup);
					editor.innerHTML = markup;
				}
				return markup !== editor.innerHTML ? markup : false;
			}
		},
		problemInfo: (el) => {
			return TextUtils.countWords(el.textContent) + ' words';
		}
	},
	{
		id: 'too-many-words',
		label: 'No paragraphs with more than [maxWordsPerParagraph] words',
		section: 'content',
		test: (pageContent, settings) => {

			const markup = Markup.createMarkupEl(pageContent.content);
			const paragraphs = markup.querySelectorAll('p');

			var tooManyWords = false;

			if (paragraphs.length) {
				paragraphs.forEach((p) => {
					if (TextUtils.countWords(p.textContent) > parseInt(settings.maxWordsPerParagraph)) {
						tooManyWords = true;
					}
				});
			}

			return {
				status: !tooManyWords
			}
		},
		showProblem: (settings) => {
			const editor = document.querySelector('.ql-editor');
			const markup = Markup.createMarkupEl(editor.innerHTML);
			const paragraphs = editor.querySelectorAll('p');
			paragraphs.forEach((p) => {
				let wordCount = TextUtils.countWords(p.textContent);
				if (wordCount > parseInt(settings.maxWordsPerParagraph)) {
					p.classList.add('mark');
				} else {
					p.classList.remove('mark');
				}
			});
			return markup.innerHTML !== editor.innerHTML ? markup.innerHTML : false;
		},
		problemInfo: (el) => {
			return TextUtils.countWords(el.textContent) + ' words';
		}
	},
	{
		id: 'too-many-sentences',
		label: 'No paragraphs with more than [maxSentencesPerParagraph] sentences',
		section: 'content',
		test: (pageContent, settings) => {
			const markup = Markup.createMarkupEl(pageContent.content);
			const paragraphs = markup.querySelectorAll('p');

			var tooManySentences = false;

			if (paragraphs.length) {
				paragraphs.forEach((p) => {
					var sentences = p.textContent.split(/\. |\? |!/);
					sentences = sentences.filter((el) => {
						return !!el.trim();
					});

					if (sentences.length > parseInt(settings.maxSentencesPerParagraph)) {
						tooManySentences = true;
					}
				});
			}

			return {
				status: !tooManySentences
			}
		},
		showProblem: (settings) => {
			const editor = document.querySelector('.ql-editor');
			const markup = Markup.createMarkupEl(editor.innerHTML);
			const paragraphs = editor.querySelectorAll('p');

			paragraphs.forEach((p) => {
				var sentences = p.textContent.split(/\. |\? |! /);
				sentences = sentences.filter((el) => {
					return !!el.trim();
				});
				if (sentences.length > parseInt(settings.maxSentencesPerParagraph)) {
					p.classList.add('mark');
				} else {
					p.classList.remove('mark');
				}
			});
			return markup.innerHTML !== editor.innerHTML ? Markup.removeEmptyLines(markup.innerHTML) : false;
		},
		problemInfo: (el) => {
			var sentences = el.textContent.split(/\. |\? |! /);
			sentences = sentences.filter((s) => {
				return !!s.trim();
			});
			return `${sentences.length} sentences`;
		}
	},
	{
		id: 'max-words-in-first-p',
		label: 'Number of words in 1st paragraph does not exceed [maxWordsInIntro]',
		section: 'content',
		inPro: true,
		test: (inputData, settings) => {
			const markup = document.createElement('div');
			markup.innerHTML = inputData.content;
			const firstP = markup.querySelector('p');
			if (!firstP) {
				return {
					status: true,
				}
			}
			let wordCount = TextUtils.countWords(firstP.textContent);
			return {
				status: wordCount <= parseInt(settings.maxWordsInIntro),
			}
		},
		showProblem: (settings) => {
			const editor = document.querySelector('.ql-editor');
			const markup = Markup.createMarkupEl(editor.innerHTML);
			const paragraph = editor.querySelector('p');
			let wordCount = TextUtils.countWords(paragraph.textContent);
			if (wordCount > settings.maxWordsInIntro) {
				paragraph.classList.add('mark');
			} else {
				paragraph.classList.remove('mark');
			}
			return markup.innerHTML !== editor.innerHTML ? Markup.removeEmptyLines(markup.innerHTML) : false;
		},
		problemInfo: (el) => {
			if (!el) {
				return '';
			}
			let wordCount = TextUtils.countWords(el.textContent);
			return `${wordCount} words`;
		}
	},
	{
		id: 'heading-length',
		label: 'Headings are not longer than 10 words',
		section: 'content',
		inPro: true,
		test: (inputData, settings) => {
			const markup = document.createElement('div');
			markup.innerHTML = inputData.content;
			const wordLimit = 10;
			const headings = markup.querySelectorAll('h1, h2, h3, h4, h5, h6');

			let status = true;
			if (headings) {
				headings.forEach((heading) => {
					var words = TextUtils.countWords(heading.textContent);
					if (words > wordLimit) {
						status = false;
					}
				});
			}
			return  {
				status: status
			};
		},
		showProblem: (settings) => {
			const editor = document.querySelector('.ql-editor');
			const markup = Markup.createMarkupEl(editor.innerHTML);
			const headings = editor.querySelectorAll('h1, h2, h3, h4, h5, h6');
			const wordLimit = 10;

			headings.forEach((heading) => {
				let wordCount = TextUtils.countWords(heading.textContent);
				if (wordCount > wordLimit) {
					heading.classList.add('mark');
				} else {
					heading.classList.remove('mark');
				}
			});
			return markup.innerHTML !== editor.innerHTML ? Markup.removeEmptyLines(markup.innerHTML) : false;
		},
		problemInfo: (el) => {
			return `${TextUtils.countWords(el.textContent)} words`;
		}
	},
	{
		id: 'heading-separation',
		label: 'Paragraphs properly separated by headings',
		section: 'content',
		inPro: true,
		test: (pageContent, settings) => {
			let {content} = pageContent;
			const markup = Markup.createMarkupEl(content);

			const elements = markup.querySelectorAll('p, h1, h2, h3, h4, h5, h6');
			let pCount = 0;
			let status = true;
			elements.forEach(el => {
				if (el.tagName.toLowerCase() === 'p' && el.textContent.trim() !== '') {
					pCount ++;
					if (pCount > parseInt(settings.maxParagraphsPerHeading)) {
						status = false;
					}
				} else {
					pCount = 0;
				}
			});
			return  {
				status: status
			};
		}
	},
	{
		id: 'strong-present',
		label: 'Contains bold text (strong tag)',
		section: 'content',
		test: (pageContent) => {
			return {
				status: !!Markup.countElements(pageContent.content, 'strong')
			};
		}
	},
	{
		id: 'post-title-length',
		label: 'Post/page title contains not more than 10 words',
		section: 'content',
		test: (pageContent) => {
			let {content} = pageContent;
			const markup = Markup.createMarkupEl(content);
			const title = markup.querySelector('h1') ? markup.querySelector('h1').textContent : '';
			return {
				status: TextUtils.countWords(title) <= 10
			}
		},
		inPro: true,
	},
	{
		id: 'minimal-word-count',
		label: 'Minimal word count',
		section: 'content',
		inPro: true,
		needsSeoData: true,
		test: (pageContent, settings) => {
			let {content, optimal} = pageContent;
			let text = Markup.stripTags(content);
			let wordCount = TextUtils.countWords(text);
			let minimalWordCount = 300;
			if (settings.minContentLength) {
				minimalWordCount = settings.minContentLength;
			} else if (optimal.optimalWordCount) {
				minimalWordCount = Math.round(0.7 * optimal.optimalWordCount);
			}
			return {
				status: wordCount >= minimalWordCount,
				optimalMin: minimalWordCount,
			}
		}
	},
	{
		id: 'optimal-word-count',
		label: 'Optimal word count',
		inPro: true,
		section: 'content',
		valueFieldName: 'optimalWordNumber',
		needsSeoData: true,
		test: (pageContent, settings) => {
			var {content, optimal} = pageContent;
			const {optimalWordCount} = optimal;

			if (!(settings.minContentLength && settings.maxContentLength) && !optimalWordCount) {
				return {
					status: false
				};
			}
			let minValue = parseInt(settings.minContentLength) || Math.round(0.7 * optimalWordCount);
			let maxValue = parseInt(settings.maxContentLength) || Math.round(1.3 * optimalWordCount);

			let wordCount = 0;
			if (!!content) {
				content = content.replaceAll('</', ' </');
				content = Markup.stripTags(content);
				wordCount = TextUtils.countWords(content);
			}

			return {
				status: wordCount >= minValue && wordCount <= maxValue,
				optimalMin: minValue,
				optimalMax: maxValue,
				value: wordCount
			}
		}
	},
	{
		id: 'optimal-heading-number',
		label: 'Optimal number of subheadings',
		inPro: true,
		section: 'content',
		valueFieldName: 'optimalHeadingNumber',
		needsSeoData: true,
		test: (pageContent) => {
			var {content, optimal} = pageContent;
			const {optimalHeadingCount} = optimal;

			if (!optimalHeadingCount) {
				return {
					status: false,
				}
			}

			const minHeadingCount = Math.round(0.7 * optimalHeadingCount);
			const maxHeadingCount = Math.round(1.3 * optimalHeadingCount);
			const headingCount = !!content ? Markup.countElements(content, 'h2, h3, h4, h5, h6') : 0;

			return {
				status: headingCount >= minHeadingCount && headingCount <= maxHeadingCount,
				optimalMin: minHeadingCount,
				optimalMax: maxHeadingCount,
				value: headingCount,
			}
		}
	},

	{
		id: 'optimal-image-number',
		label: 'Optimal number of images',
		inPro: true,
		section: 'content',
		valueFieldName: 'optimalImageNumber',
		excludeFromScore: true,
		needsSeoData: true,
		test: (pageContent, settings) => {
			var {content, optimal} = pageContent;
			const {optimalImageCount} = optimal;
			if (!optimalImageCount && optimalImageCount !== 0) {
				return {
					status: 'info',
				}
			}

			const minImageCount = Math.round(0.7 * optimalImageCount);
			const maxImageCount = Math.round(1.3 * optimalImageCount);
			const imageCount = !!content ? Markup.countElements(content, 'img') : 0;

			return {
				status: 'info',
				optimalMin: minImageCount,
				optimalMax: maxImageCount,
				value: imageCount
			}
		}
	},
	{
		id: 'no-disallowed-words',
		label: 'No disallowed words in text',
		section: 'content',
		test: (pageContent, settings) => {
			let {content} = pageContent;
			if (!content || !settings.disallowedWords) {
				return {
					status: true
				};
			}
			content = Markup.stripTags(content).toLowerCase();
			content = content.replace(/(\r\n|\n|\r)/gm, ' ');
			content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
			const words = content.split(' ');
			const bad = settings.disallowedWords.split(/\r?\n/).map((word) => word.trim());
			let result = words.filter((word) => bad.includes(word));
			return {
				status: !result.length,
			}
		},
		showProblem: (settings) => {
			const editor = document.querySelector('.ql-editor');
			let content = editor.innerHTML;
			if (!content) {
				return false;
			}
			const bad = settings.disallowedWords.split(/\r?\n/).map((word) => word.trim());

			content = Markup.stripTags(content);
			content = content.replace(/(\r\n|\n|\r)/gm, ' ');
			content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
			const words = content.split(' ');

			let markup = editor.innerHTML;
			const marks = editor.querySelectorAll('mark');
			if (marks.length) {
				markup = markup.replaceAll('<mark>','');
				markup = markup.replaceAll('</mark>','');
			}

			words.forEach((word) => {
				if (!word) {
					return;
				}
				if (bad.includes(word.toLocaleLowerCase())) {
					markup = markup.replaceAll(word, `<mark>${word}</mark>`);
				}
			});
			if (markup !== editor.innerHTML) {
				markup = Markup.removeEmptyLines(markup);
				editor.innerHTML = markup;
				return markup;
			}
			return false;
		}
	},
	{
		id: 'uppercase-not-overused',
		label: 'Uppercase not overused',
		section: 'content',
		inPro: true,
		test: (pageContent, settings) => {
			var {content} = pageContent;
			if (!content) {
				return {
					status: true
				}
			}

			content = Markup.stripTags(content);
			content = content.replace(/(\r\n|\n|\r)/gm, ' ');
			content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
			const words = content.split(' ').filter((word) => word.trim());

			let uppercaseCount = 0;
			let status = true;
			words.forEach((word) => {
				if (word === word.toUpperCase()) {
					uppercaseCount ++;
				} else {
					uppercaseCount = 0;
				}

				if (uppercaseCount >= 3) {
					status = false;
				}
			});

			return {
				status: status
			}
		},
	},
	{
		id: 'keyword-exists',
		label: 'Keyword is provided',
		section: 'keyword',
		test: (pageContent) => {
			return {
				status: !!pageContent.keyword
			}
		}
	},
	{
		id: 'keyword-in-h1',
		label: 'Keyword present in H1 element',
		section: 'keyword',
		test: (pageContent) => {
			var {keyword, content} = pageContent;
			return {
				status: Markup.isPhraseInAnyElement(keyword, content, 'h1')
			}
		}
	},

	{
		id: 'keyword-not-in-ext-link',
		label: 'Keyword NOT present in external link text',
		section: 'keyword',
		test: (pageContent) => {
			const {keyword, content, siteUrl} = pageContent;
			if (!keyword) {
				return {
					status: true
				};
			}

			const markup = Markup.createMarkupEl(content);
			var result = false;
			let siteAddress;
			try {
				siteAddress = new URL(siteUrl);
			} catch {
				return {
					status: true
				};
			}

			const links = markup.querySelectorAll('a');
			links.forEach(link => {
				const url = link.getAttribute('href') || '';
				result = !url.includes('http://' + siteAddress.hostname) &&
					!url.includes('https://' + siteAddress.hostname) &&
					url.substring(0, 1) !== '/' && url.substring(0, 2) !== './' &&
					TextUtils.isPhraseInText(keyword, link.textContent);
			});

			return {
				status: !result
			}
		}
	},
	{
		id: 'keyword-in-first-words',
		label: 'Keyword present within first 100 words',
		section: 'keyword',
		test: (pageContent) => {
			var {keyword, content} = pageContent;
			if (!keyword) {
				return {
					status: false
				};
			}

			keyword = keyword.trim().toLowerCase();
			content = Markup.stripTags(content);

			var words = content.toLowerCase().split(/\s|\n/);
			words = words.filter((el) => { return el; });
			const limit = words.length >= 100 ? 100 : words.length;
			words = words.splice(0, limit);

			if (!TextUtils.isPhraseInText(keyword, words.join(' '))) {
				return {
					status: false
				};
			}

			let keywordWordsCount = keyword.split(' ');
			if (keywordWordsCount.length > 1) {
				return {
					status: true
				};
			}

			if (words.length) {
				for (let i = 0; i < limit; i++) {
					words[i] = words[i].replace('.', '');
					words[i] = words[i].replace(',', '');
					words[i] = words[i].replace('?', '');
					words[i] = words[i].replace('!', '');
					words[i] = words[i].replace(':', '');
					words[i] = words[i].replace(';', '');
					words[i] = words[i].replace('-', '');
				}
			}

			return {
				status: words.includes(keyword)
			}
		}
	},
	{
		id: 'keyword-in-last-words',
		label: 'Keyword present within last 100 words',
		section: 'keyword',
		inPro: true,
		test: (pageContent) => {
			var {keyword, content} = pageContent;
			if (!keyword) {
				return {
					status: false
				};
			}

			content = Markup.stripTags(content);
			keyword = keyword.trim().toLowerCase();

			var words = content.toLowerCase().split(/\s|\n/);
			words = words.filter((el) => el);
			words = words.slice(Math.max(words.length - 100, 0));
			const limit = words.length >= 100 ? 100 : words.length;

			if (!TextUtils.isPhraseInText(keyword, words.join(' '))) {
				return {
					status: false
				};
			}

			let keywordWordsCount = keyword.split(' ');
			if (keywordWordsCount.length > 1) {
				return {
					status: true
				};
			}

			if (words.length) {
				for (let i = 0; i < limit; i++) {
					words[i] = words[i].replace('.', '');
					words[i] = words[i].replace(',', '');
					words[i] = words[i].replace('?', '');
					words[i] = words[i].replace('!', '');
					words[i] = words[i].replace(':', '');
					words[i] = words[i].replace(';', '');
				}
			}

			return {
				status: words.includes(keyword)
			}
		}
	},
	{
		id: 'keyword-in-h2',
		label: 'Keyword present in H2 heading',
		section: 'keyword',
		inPro: true,
		test: (pageContent) => {
			const {keyword, content} = pageContent;
			return {
				status: Markup.isPhraseInAnyElement(keyword, content, 'h2')
			}
		}
	},
	{
		id: 'keyword-in-image-filename',
		label: 'Keyword in image file name',
		section: 'keyword',
		inPro: true,
		excludeFromScore: true,
		test: (pageContent) => {
			const {keyword, content} = pageContent;

			if (!keyword) {
				return {
					status: false
				};
			}

			let result = 'info';
			const markup = Markup.createMarkupEl(content);
			const images = markup.querySelectorAll('img');
			if (images) {
				images.forEach((image) => {
					let url = image.getAttribute('src');
					let lastSlash = url.lastIndexOf('/');
					let filename = url.substring(lastSlash);
					if (TextUtils.isPhraseInText(TextUtils.slugify(keyword), filename)) {
						result = true;
					}
				});
			}

			return {
				status: result
			}
		}
	},
	{
		type: 'configField',
		section: 'internal-links',
		fieldName: 'domain',
		fieldLabel: 'Site URL',
		fieldType: 'url',
		contentField: 'siteUrl',
		callbackPropName: 'domainCallback',
	},
	{
		id: 'internal-links-present',
		label: 'Contains internal links',
		section: 'internal-links',
		test: (pageContent) => {
			let {content, siteUrl} = pageContent;
			if (!siteUrl) {
				return  {
					status: false
				};
			}
			const markup = Markup.createMarkupEl(content);
			const links = markup.querySelectorAll('a');
			let siteAddress;
			try {
				siteAddress = new URL(siteUrl);
			} catch {
				return {
					status: false
				};
			}

			var internalLinksPresent = false;
			links.forEach(link => {
				var url = link.getAttribute('href') || '';
				if (!url) {
					return {
						status: false
					};
				}
				if (url.includes('http://' + siteAddress.hostname) || url.includes('https://' + siteAddress.hostname) || url.substring(0, 1) === '/' || url.substring(0, 2) === './') {
					internalLinksPresent = true;
				}
			});

			return  {
				status: internalLinksPresent
			}
		},
	},
	{
		id: 'readability',
		label: 'Readability score',
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let {content} = pageContent;
			if (!content) {
				return {
					value: 'N/A',
					comment: '',
					status: 'nok',
				}
			}
			content = Markup.stripTags(content);

			var sentences = content.split(/\.|\?|!/);
			sentences = sentences.map(sentence => {
				return sentence.trim();
			})
			sentences = sentences.filter(sentence => {
				return sentence && sentence !== " " && sentence !== '\n';
			});

			content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');

			var words = content.split(' ');
			words = words.map(word => {
				return word.trim();
			})
			words = words.filter(word => {
				return word && word !== '' && word !== '\n';
			})
			const syllableCount = TextUtils.countSyllables(content);

			var score = 206.835 - 1.015 * (words.length / sentences.length) - 84.6 * (syllableCount / words.length);
			score = score.toFixed(2);
			if (score < 0) {
				score = 0;
			} else if (score > 100) {
				score = 100;
			}
			var comment = '';
			var status = 'info';

			switch (true) {
				case isNaN(score):
					score = 'N/A';
					comment = '';
					break;
				case score > 90:
					comment = 'Very easy to read';
					break;
				case score > 80 && score <= 90:
					comment = 'Easy to read';
					break;
				case score > 70 && score <= 80:
					comment = 'Fairly easy to read';
					break;
				case score > 60 && score <= 70:
					comment = 'Average reading ease';
					break;
				case score > 50 && score <= 60:
					comment = 'Fairly difficult to read';
					break;
				case score > 30 && score <= 50:
					comment = 'Difficult to read';
					break;
				case score > 10 && score <= 30:
					comment = 'Very difficult to read';
					break;
				default:
					comment = 'Extremely difficult to read';
					break;
			}

			if (comment) {
				comment = `(${comment})`;
			}

			return {
				value: score,
				comment: comment,
				status: status
			}
		}
	},
	{
		id: 'words',
		label: 'Words',
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let text = Markup.stripTags(pageContent.content);
			return {
				value: TextUtils.countWords(text),
				status: 'info'
			}
		}
	},
	{
		id: 'chars',
		label: 'Characters',
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let text = Markup.stripTags(pageContent.content);
			return {
				value: text.length || 0,
				status: 'info',
			}
		}
	},
	{
		id: 'sentences',
		label: 'Sentences',
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let {content} = pageContent;
			content = Markup.stripTags(content);
			content = content.replace(/(\r\n|\n|\r)/gm, ' ');

			var sentences = content.split(/\.|\?|!/);
			sentences = sentences.map(sentence => {
				return sentence.trim();
			})
			sentences = sentences.filter(sentence => {
				return sentence && sentence !== " " && sentence !== '\n';
			});

			return {
				value: sentences.length || 0,
				status: 'info',
			}
		}
	},
	{
		id: 'paragraphs',
		label: 'Paragraphs',
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			pageContent = pageContent.content;
			return {
				value: Markup.countElements(pageContent, 'p'),
				status: 'info',
			}
		}
	},
	{
		id: 'headings',
		label: 'Headings',
		inPro: true,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			return {
				value: Markup.countElements(pageContent.content, 'h1, h2, h3, h4, h5, h6'),
				status: 'info',
			}
		}
	},
	{
		id: 'images',
		label: 'Images',
		inPro: true,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			return {
				value: Markup.countElements(pageContent.content, 'img'),
				status: 'info',
			}
		}
	},
	{
		id: 'est-reading-time',
		label: 'Estimated reading time',
		section: 'info',
		order: 'label value',
		excludeFromScore: true,
		test: (pageContent) => {
			let {content} = pageContent;
			var wordCount = TextUtils.countWords(content);
			var wpm = 225;
			var mins = Math.floor(wordCount / wpm);
			var secs = Math.floor(wordCount % wpm / (wpm / 60));
			return {
				value: `${mins} min ${secs} s`,
				status: 'info',
			}
		}
	},
];

export default checks;